import {
  Button,
  Typography,
  Row,
  Col,
  Drawer,
  Table,
  Space,
  Popconfirm,
  Tag,
  Modal,
} from "antd";
import { useEffect, useState } from "react";
import { PlusOutlined } from "@ant-design/icons";
import { useSelector } from "react-redux";
import toast from "react-hot-toast";
import { DeleteDataOnServer, GetDataListFromServer, UpdateUnlockDataOnServer } from "../../lib/api";
import { OPERATOR_DELETE, OPERATOR_GET_LIST, OPERATOR_UNLOCK } from "../../lib/config";
import { QUERY_OPERATOR } from "../../lib/query_obj";
import { queryHandler } from "../../lib/global_functions";
import OperatorForm from "./form";
import ResetModal from "./reset_modal";

const { Text } = Typography;
export default function Operator() {
  const { access_token, permissions, ui_size, csrf_token } = useSelector(
    (state) => state.user
  );
  const [loading, setLoading] = useState(false);
  const [list, setList] = useState([]);
  const [showForm, setShowForm] = useState(false);
  const [edit, setEdit] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [operator, setOperator] = useState(false);

  const [pagin, setPagin] = useState({
    page_number: 1,
    per_page: 10,
    total: 0,
  });

  const [filter, setFilter] = useState({
    name: "",
    order_by: "created_at",
    order_type: "DESC",
  });

  async function getDataList(page_number, per_page) {
    setLoading(true);
    await GetDataListFromServer(
      OPERATOR_GET_LIST,
      queryHandler(filter, QUERY_OPERATOR, { page_number, per_page }),
      access_token
    )
      .then(({ data: { data: res, total } }) => {
        setLoading(false);
        setPagin((prev) => ({ ...prev, page_number, per_page, total }));
        setList(res);
      })
      .catch((error) => {
        setLoading(false);
        toast.error(error?.response?.data?.error || "Connection Error");
      });
  }

  useEffect(() => {
    getDataList(pagin.page_number, pagin.per_page);
  }, []);

  const columns = [
    {
      title: "Code",
      dataIndex: "code",
    },
    {
      title: "Name",
      dataIndex: "name",
    },
    {
      title: "Phone",
      dataIndex: "phone",
    },
    {
      title: "Is Active?",
      dataIndex: "is_active",
      render: (record) => {
        return (
          <Tag color={record ? "lime" : "red"}>
            <Text style={{ fontSize: "15px", color: record ? "lime" : "red" }}>
              {record ? "Yes" : "No"}
            </Text>
          </Tag>
        );
      },
    },
    {
      title: "Is Locked?",
      dataIndex: "is_locked",
      render: (record) => {
        return (
          <Tag color={record ? "lime" : "red"}>
            <Text style={{ fontSize: "15px", color: record ? "lime" : "red" }}>
              {record ? "Yes" : "No"}
            </Text>
          </Tag>
        );
      },
    },
    {
      title: "Actions",
      dataIndex: "actions",
      width:"400px",
      render: (_, record) => (
        <Row justify="end">
        <Space>
          {permissions.includes("AGENT_UPDATE_OPERATOR") && (
              <Popconfirm
              title="Are you sure to delete?"
              okText="Yes"
              cancelText="No"
              onConfirm={() => unlockOperator(record.id)}
            >
            <Button size={ui_size} type="primary" disabled={!record.is_locked}>
              Unlock
            </Button>
            </Popconfirm>
          )}
          {permissions.includes("AGENT_UPDATE_OPERATOR") && (
            <Button
              size={ui_size}
              type="primary"
              onClick={() => openModal(record)}
            >
              Password Reset
            </Button>
          )}
          {permissions.includes("AGENT_UPDATE_OPERATOR") &&
          <Button
            size={ui_size}
            type="primary"
            onClick={() => editHandler(record)}
          >
            Edit
          </Button>
    }

          {permissions.includes("AGENT_DELETE_OPERATOR") && (
            <Popconfirm
              title="Are you sure to delete?"
              okText="Yes"
              cancelText="No"
              onConfirm={() => deleteHandler(record.id)}
            >
              <Button size={ui_size} type="primary" danger>
                Delete
              </Button>
            </Popconfirm>
          )}
        </Space>
        </Row>
      ),
    },
  ];

  const openDrawer = () => setShowForm(true);

  function closeDrawer(key) {
    setShowForm(false);
    setEdit(false);
    if (key) {
      getDataList(pagin.page_number, pagin.per_page);
    }
  }

  function editHandler(record) {
    setShowForm(true);
    setEdit(record);
  }

  function openModal(record) {
    setShowModal(true);
    setOperator(record);
  }

  async function deleteHandler(id) {
    setLoading(true);

    await DeleteDataOnServer(OPERATOR_DELETE, id, access_token, csrf_token)
      .then(() => {
        setLoading(false);
        toast.success("Deleted operator successfully");
        getDataList(pagin.page_number, pagin.per_page);
      })
      .catch(() => {
        setLoading(false);
        toast.error("Delete failed");
      });
  }

  async function unlockOperator(id) {
    setLoading(false)
    await UpdateUnlockDataOnServer(OPERATOR_UNLOCK, id, access_token, csrf_token)
    .then(() => {
      setLoading(false)
      toast.success("Unlocked operator successfully")
      getDataList(pagin.page_number, pagin.per_page)
    }).catch(() => {
      setLoading(false)
      toast.error("Unlock failed")
    })
  }


  return (
    <>
      <Row gutter={[16, 24]} justify="end">
        <Col>
          {permissions.includes("AGENT_CREATE_OPERATOR") && (
            <Button
              size={ui_size}
              type="primary"
              icon={<PlusOutlined />}
              onClick={openDrawer}
            >
              New Operator
            </Button>
          )}
        </Col>

        <Col span={24}>
          <Table
            size={ui_size}
            loading={loading}
            columns={columns}
            dataSource={list}
            rowKey={(e) => e.id}
            pagination={{
              total: pagin.total,
              defaultCurrent: 1,
              defaultPageSize: 10,
              showSizeChanger: true,
              pageSizeOptions: [10, 20, 50],
              onChange: (pageNumber, perPage) => {
                getDataList(pageNumber, perPage);
              },
            }}
          />
        </Col>
      </Row>
      <Drawer
        open={showForm}
        title={edit ? "Update Operator Form" : "Create Operator Form"}
        width={1200}
        destroyOnClose
        onClose={() => closeDrawer()}
      >
        <OperatorForm edit={edit} closeDrawer={closeDrawer} />
      </Drawer>
      <Modal
        footer={null}
        title="Operator Password Reset Form"
        open={showModal}
        onCancel={() => setShowModal(false)}
        destroyOnClose
      >
        <ResetModal operator={operator} />
      </Modal>
    </>
  );
}
